import BodyContainer from "../components/BodyContainer";
import {useNavigate, useParams} from "react-router-dom";
import {useState} from "react";
import {fetchEventByIdFromDatabase} from "../handlers/databasehandler";
import ProgressRing from "../components/ProgressRing";
import Title from "../components/Title";
import IconText from "../components/IconText";
import {
    Calendar16Regular,
    Edit12Regular, Edit16Regular,
    Flag16Regular, ListBar16Regular,
    Location16Regular,
    Mail16Regular
} from "@fluentui/react-icons";
import {Button} from "@fluentui/react-components";
import MessageBox from "../components/MessageBar";

const EventView = () => {
    const navigate = useNavigate();

    const { id } = useParams();
    const [dataFetched, setDataFetched] = useState(false);
    const [localEvent, setLocalEvent] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const [msg, setMsg] = useState(null);
    const [msgIntent, setMsgIntent] = useState(null);
    const [msgTitle, setMsgTitle] = useState(null);

    async function fetchEvents() {
        return await fetchEventByIdFromDatabase(id);
    }

    function setMessageData(title, message, intent) {
        setMsgIntent(intent);
        setMsgTitle(title);
        setMsg(message);
    }

    if (!dataFetched) {
        setDataFetched(true);
        fetchEvents().then((data) => {
            if (data == null) {
                setMessageData("Event cannot be loaded", "An error has occurred loading the event", "error");
                setIsLoading(false);
            } else {
                setLocalEvent(data);
                setIsLoading(false);
            }
        });
    }

    return (
        <BodyContainer showBackButton={true} content={
            <>
                {msg != null ? (
                    <MessageBox
                        intent={msgIntent}
                        title={msgTitle}
                        message={msg}
                        closeButtonFunction={() => { setMsg(null) }}
                    />
                ) : null}
                {(isLoading) ? <ProgressRing/> : null}
                {(!isLoading && msg == null) ?
                        <>
                            <Title title={localEvent.name} subtitle={`Inschrijven voor ${localEvent.name}`}/>
                            <IconText icon={<Location16Regular/>} text={localEvent.location}/>
                            <IconText icon={<Calendar16Regular/>} text={`${localEvent.startDate} - ${localEvent.endDate}`}/>
                            <IconText icon={<Mail16Regular/>} text={<a className={`a-no-underline`} href={`mailto:${localEvent.contact_email}`}>{localEvent.contact_email}</a>}/>
                            <IconText icon={<Flag16Regular/>} text={localEvent.race_type}/>
                            <p style={{ display: "inline-block" }}>
                                De inschrijving voor dit evenement wordt gedaan via Klokking. Wanneer er op 'Inschrijven' wordt geklikt, gaat u akkoord met de <a href={"#/privacy"}>privacyverklaring</a>.
                            </p>
                            <div className={`flex flex-gap-medium flex-wrap`}>
                                <Button as={"a"} className={`button`} appearance="primary" onClick={() => { navigate(`/${id}/register`);}}><Edit16Regular/> Inschrijven</Button>
                                <Button as={"a"} className={`button`} appearance="primary" onClick={() => { navigate(`/${id}/schedule`);}}><ListBar16Regular/> Wedstrijdschema & Uitslagen</Button>
                            </div>
                        </>
                    : null }
            </>
        } />
    )
}

export default EventView;